/**
 * Component which represents a "reserved" spot on the map, which cannot share the same spot with
 * another obstacle. Doors, fridges, level objects you can't pass through.
 */
export function Updater(base) {
    return class extends base {
        endStep(step) { }
        startStep(step) { }
        update(step, duration) { }
    };
}
export function isUpdater(obj) {
    return 'update' in obj;
}
